<template lang="pug">
include /mixins
+b.input-group
  div(
    class='g-recaptcha'
    tabindex='-1'
  )
  +e.error.SPAN(
    v-show="error"
  ) {{ error }}
</template>
<script>

// import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'Captcha',
  // components: {
  //   VueRecaptcha,
  // },
  props: {
    error: {
      default: '',
    },
    reset: {
      default: '',
    },
    value: {},
    reloader: {},
    id: {
      default: 'recaptcha',
    },
    getCaptcha: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      captcha: this.value,
      key: window.enterprise_recaptcha,
    }
  },
  watch: {
    reset() {
      this.$refs.recaptcha.reset()
    },
    reloader() {
      this.$refs.recaptcha.reset()
    },
  },
  async created() {
  },
  async mounted() {
    this.scriptAppend()
  },
  methods: {
    scriptAppend() {
      console.log(window.grecaptcha);
      if (window.grecaptcha) return
      // window.onloadCallback = () => {
      //   window.grecaptcha.enterprise.render(document.getElementById(this.id), {
      //     sitekey: this.key,
      //     action: "verify",
      //     callback: (token) => {
      //       window.recaptcha_token = token;
      //       console.log("recaptcha token : ", token);
      //     },
      //   });
      // };
      console.log('CREATE');
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute(
        'src',
        `https://www.google.com/recaptcha/enterprise.js?render=${this.key}`
      )
      recaptchaScript.setAttribute('async', 'true')
      recaptchaScript.setAttribute('defer', 'true')
      document.head.appendChild(recaptchaScript);
      this.creater()
    },
    captchaCreater() {
      // if (Array.from(document.getElementsByClassName('g-recaptcha')).length) return
      // window.grecaptcha.enterprise.render(document.getElementById(this.id), {
      //   sitekey: this.key,
      //   action: 'verify',
      //   // callback: this.onSubmitFn,
      //   callback: (token) => {
      //     window.recaptcha_token = token;
      //     console.log("recaptcha token : ", token);
      //   },
      // })
      // window.grecaptcha.render(, {
      //   sitekey: this.key,
      //   callback: this.onSubmitFn,
      // })
    },
    creater() {
      const ff = document.getElementById(this.id)
      if (!window.grecaptcha) {
        console.log('Google Recaptcha script is missing')
      }
      let inst = null
      setTimeout(() => {
        inst = setInterval(() => {
          if (window.grecaptcha?.enterprise && ff) {
            this.captchaCreater()
            clearInterval(inst)
          }
        }, 1000)
      }, 1000)
    },
    onSubmitFn(v) {
      this.captcha = v
      this.getCaptcha(v)
    },
    onSubmit(v) {
      this.captcha = v
      this.getCaptcha(v)
    },
    reload() {
      window.grecaptcha.execute()
    },
    setValue(event) {
      this.captcha = event
      this.$emit('input', this.captcha)
    },
    onExpiredReset() {
      this.captcha = ''
    },
  },
}
</script>
